import { HelpCircle } from "lucide-react";
import { useLang } from "@/i18n";

const QA = [
  {
    q_tr: "Ücretli API üçüncü taraf haberlerini sunuyor mu?",
    q_en: "Does the paid API include third-party news?",
    a_tr: "Hayır. Ücretli Loft Press API üçüncü taraf yayıncı haberlerini, RSS akışlarını veya haricî haber API verilerini müşterilere sunmaz. API yalnızca Loft Press'in kendi üretim ve editoryal onay sürecinde oluşturulan içerikleri sağlar.",
    a_en: "No. The paid Loft Press API does not deliver third-party publisher news, RSS feeds or external news API data. The API only provides content created within Loft Press's own production and editorial-approval workflow.",
  },
  {
    q_tr: "İçerikler nasıl oluşturuluyor?",
    q_en: "How is content created?",
    a_tr: "Konu ve başlık Loft Press operatörü tarafından belirlenir. İçerik yapay zekâ destekli sistemle oluşturulur, otomatik güvenlik kontrollerinden geçirilir ve manuel olarak onaylandıktan sonra API üzerinden yayınlanır.",
    a_en: "Topics and titles are selected by the Loft Press operator. Content is generated with an AI-assisted system, processed through automated safety controls, and published via the API only after manual approval.",
  },
  {
    q_tr: "İçerikler otomatik olarak yayınlanıyor mu?",
    q_en: "Is content published automatically?",
    a_tr: "Hayır. İçerikler manuel editoryal onay tamamlanmadan ücretli API üzerinden yayınlanmaz.",
    a_en: "No. Content is not published through the paid API until manual editorial approval is completed.",
  },
  {
    q_tr: "Her müşteri aynı içeriği mi alır?",
    q_en: "Does every customer receive the same content?",
    a_tr: "Genel API havuzundaki içeriklere ek olarak, uygun planlarda müşteriye özel yeni içerikler veya içerik varyasyonları üretilebilir.",
    a_en: "In addition to content in the general API pool, customer-specific new content or variations may be produced on eligible plans.",
  },
  {
    q_tr: "Gerçek kişilerin yüzü veya sesi kullanılıyor mu?",
    q_en: "Do you use real people's faces or voices?",
    a_tr: "Hayır. Ücretli API gerçek kişi benzerliği, face swap, deepfake veya ses klonlama hizmeti sunmaz. Görsel ve videolarda insan olmayan nesne karakterleri ve soyut illüstrasyonlar; seslerde ticari lisanslı sentetik kütüphane sesleri kullanılır.",
    a_en: "No. The paid API does not provide real-person likeness, face swap, deepfake or voice-cloning services. Non-human object characters and abstract illustrations are used for visual and video content; commercially licensed synthetic library voices are used for audio.",
  },
  {
    q_tr: "SEO sonucu garanti ediliyor mu?",
    q_en: "Are SEO results guaranteed?",
    a_tr: "Hayır. İçerikler yapılandırılmış başlıklar, özetler, anahtar kelime alanları ve makine tarafından işlenebilir meta veriler içerebilir. Loft Press sıralama, trafik, etkileşim veya ticari sonuç garantisi vermez.",
    a_en: "No. Content may include structured titles, summaries, keyword fields and machine-readable metadata. Loft Press does not guarantee search rankings, traffic, engagement or commercial results.",
  },
  {
    q_tr: "API kullanım birimleri nakde çevrilebilir mi?",
    q_en: "Can API usage units be converted to cash?",
    a_tr: "Hayır. API kullanım birimlerinin nakit değeri yoktur, kullanıcılar arasında aktarılamaz ve yalnızca Loft Press API hizmetinde kullanılabilir.",
    a_en: "No. API usage units have no cash value, cannot be transferred between users and may only be used within the Loft Press API service.",
  },
  {
    q_tr: "Sağlık içerikleri tıbbi tavsiye mi sunuyor?",
    q_en: "Do health items provide medical advice?",
    a_tr: "Hayır. Sunulan içerikler genel eğitim, bilim ve anatomi kategorisindedir. Teşhis, tedavi, ilaç önerisi, kişiselleştirilmiş tıbbi tavsiye veya sonuç garantisi içermez.",
    a_en: "No. Such content falls into the general education, science and anatomy category. It does not include diagnosis, treatment, medication recommendations, personalized medical advice or outcome guarantees.",
  },
];

export default function Faq() {
  const { lang } = useLang();
  const t = (tr, en) => (lang === "tr" ? tr : en);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="faq-page">
      <div className="flex items-center gap-3 mb-6">
        <HelpCircle className="text-red-500" size={28} />
        <span className="eyebrow text-red-500">SIK SORULAN SORULAR · Loft Press API</span>
      </div>
      <h1 className="headline text-5xl sm:text-6xl text-white">
        {t("Sık Sorulan Sorular", "Frequently Asked Questions")}
      </h1>

      <div className="mt-12 space-y-6">
        {QA.map((item, i) => (
          <details key={i} className="bg-neutral-950 border border-neutral-800 rounded-sm p-5 group" data-testid={`faq-${i}`}>
            <summary className="cursor-pointer list-none flex items-start justify-between gap-4">
              <h2 className="headline text-lg text-white flex-1">{lang === "tr" ? item.q_tr : item.q_en}</h2>
              <span className="text-red-500 text-xl transition-transform group-open:rotate-45">+</span>
            </summary>
            <p className="mt-4 text-base text-neutral-300 leading-relaxed">{lang === "tr" ? item.a_tr : item.a_en}</p>
          </details>
        ))}
      </div>
    </div>
  );
}
